var _defs, _tspan;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 37.357,
    height: 48.989,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500h500V0H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500h500V0H0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h500v500H0Z",
    style: {
      fill: "#e8eaeb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -698.32 386.188)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 -698.32 386.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-16.868-16.868c-1.771-1.771-4.671.255-3.619 2.527L-13.548.643a2.24 2.24 0 0 1 0 1.884l-6.939 14.984c-1.052 2.272 1.848 4.298 3.619 2.527L0 3.17A2.242 2.242 0 0 0 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(88.755 362.551)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-16.868-16.868c-1.771-1.771-4.671.255-3.619 2.527L-13.548.643a2.24 2.24 0 0 1 0 1.884l-6.939 14.984c-1.052 2.272 1.848 4.298 3.619 2.527L0 3.17A2.242 2.242 0 0 0 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(64.798 362.551)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a3.565 3.565 0 0 0-2.521 6.085l14.413 14.412-14.115 14.115a3.565 3.565 0 0 0 5.041 5.041l16.636-16.635a3.565 3.565 0 0 0 0-5.041L2.521 1.044A3.555 3.555 0 0 0 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(134.375 343.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a3.565 3.565 0 0 0-2.521 6.085l14.413 14.412-14.116 14.115a3.565 3.565 0 0 0 5.041 5.041l16.637-16.635a3.565 3.565 0 0 0 0-5.041L2.521 1.044A3.555 3.555 0 0 0 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(159.923 343.908)"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.33333 0 0 1.33333 -500.947 -199.41)",
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 15,
      fontFamily: "Quicksand",
      InkscapeFontSpecification: "Quicksand-Bold",
      writingMode: "lr-tb",
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "0 12.69 25.065001 37.185001 52.41 71.940002 79.440002 93.705002 109.38 120.825 132.27 144.16499 158.73 171.45 179.02499 194.38499",
    y: 0
  }, "ARROW COLLECTION"))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a.864.864 0 0 0-.611 1.476l3.495 3.495-3.423 3.423A.865.865 0 0 0 .684 9.616l4.034-4.034a.864.864 0 0 0 0-1.223L.611.253A.86.86 0 0 0 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -531.635 -199.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a.864.864 0 0 0-.611 1.476l3.495 3.495-3.423 3.423A.863.863 0 1 0 .683 9.616l4.035-4.034a.864.864 0 0 0 0-1.223L.611.253A.86.86 0 0 0 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -523.374 -199.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a.864.864 0 0 0 .611-1.476l-3.495-3.495L.539-8.394A.863.863 0 1 0-.683-9.616l-4.035 4.034a.864.864 0 0 0 0 1.223L-.611-.253A.86.86 0 0 0 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -198.338 -212.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a.864.864 0 0 0 .611-1.476l-3.495-3.495L.539-8.394A.864.864 0 1 0-.684-9.616l-4.034 4.034a.864.864 0 0 0 0 1.223L-.611-.253A.86.86 0 0 0 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -206.598 -212.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.13 2.13 0 0 1-3.012-3.012l6.023-6.023a2.126 2.126 0 0 1 1.506-.623 2.13 2.13 0 0 1 1.505 3.635z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -150.355 -123.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.13 2.13 0 1 1-3.012-3.012l4.518-4.517-4.518-4.517A2.13 2.13 0 0 1 0-15.058l6.023 6.023a2.127 2.127 0 0 1 0 3.012z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -136.205 -109.724)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.023-6.023a2.13 2.13 0 0 1 3.011-3.012l6.024 6.023A2.13 2.13 0 0 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -146.736 -87.147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.13 2.13 0 0 1-3.012-3.012l6.023-6.023a2.126 2.126 0 0 1 1.506-.623 2.13 2.13 0 0 1 1.505 3.635z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -116.29 -123.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.022 6.023a2.13 2.13 0 0 1-3.012-3.011l4.516-4.518-4.516-4.517a2.13 2.13 0 0 1 3.012-3.012L0-3.012C.831-2.18.831-.832 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -94.111 -101.693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.023-6.023a2.13 2.13 0 0 1 3.011-3.012l6.024 6.023A2.13 2.13 0 0 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -112.672 -87.147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.065 3.066a92.816 92.816 0 0 1-4.699 3.492C-3.25 7.672-4.901 8.752-6.659 9.725c.972-1.758 2.053-3.41 3.167-5.026A93.268 93.268 0 0 1 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -269.877 -112.151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.112 1.982a145.956 145.956 0 0 1-4.356 3.837l-3.614-3.614A147.354 147.354 0 0 1-6.245-2.15l1.899-2.024c-.65-.661-1.274-1.348-1.913-2.021-.668-.698-1.3-1.431-1.95-2.146-.652-.713-1.27-1.461-1.906-2.19l3.68-3.68c.73.636 1.477 1.253 2.191 1.905.715.651 1.448 1.283 2.145 1.951.701.665 1.419 1.312 2.104 1.991L2.07-6.333l2.195 2.159L2.07-2.026z",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -253.241 -105.287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.112-1.618-2.191-3.27-3.161-5.03 1.761.97 3.412 2.049 5.03 3.162a91.784 91.784 0 0 1 4.7 3.491L3.491 4.701A92.252 92.252 0 0 1 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -274.994 -80.564)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.065 3.066a92.816 92.816 0 0 1-4.699 3.492C-3.25 7.672-4.901 8.752-6.659 9.725c.973-1.758 2.053-3.41 3.167-5.026A93.268 93.268 0 0 1 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -230.865 -112.151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.069 2.026-2.114 1.983a148.779 148.779 0 0 1-4.354 3.837l-3.615-3.615A148.643 148.643 0 0 1-8.315-.124l1.899-2.023c-.65-.662-1.274-1.349-1.913-2.021-.668-.698-1.3-1.432-1.95-2.146-.653-.713-1.27-1.461-1.906-2.19l3.68-3.681c.73.637 1.478 1.254 2.191 1.906.714.651 1.448 1.282 2.145 1.95.7.665 1.419 1.312 2.104 1.992L0-4.306l2.194 2.158Z",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -211.47 -102.585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.113-1.618-2.192-3.27-3.162-5.03 1.761.97 3.412 2.049 5.03 3.162a91.784 91.784 0 0 1 4.7 3.491L3.49 4.701A91.641 91.641 0 0 1 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -235.98 -80.564)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.894 4.801-4.975 4.719-.27.256-.351-.351.095-.431c.146-.662.361-1.254.541-1.883l.652-1.772c.434-1.181.951-2.28 1.471-3.376C-6.673-.21-5.476-2.245-4.203-4.203A65.285 65.285 0 0 1-.084-9.779c.089-.113.187-.218.278-.328-.127-.15-.258-.295-.382-.447-1.478-1.812-2.911-3.668-4.209-5.659-1.305-1.984-2.53-4.048-3.614-6.253-.531-1.114-1.061-2.229-1.507-3.428l-.668-1.798c-.184-.639-.405-1.24-.555-1.912l-.096-.43.352-.353.27.257 5.063 4.804 4.98 4.888 9.955 9.78.535.526-.535.526z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -392.463 -113.227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-9.782 9.606-4.894 4.801-4.975 4.719-.27.257-.351-.351.095-.432c.146-.662.361-1.254.54-1.883l.653-1.771c.433-1.182.951-2.28 1.47-3.377 1.059-2.173 2.256-4.207 3.529-6.165A65.128 65.128 0 0 1-9.866-.172c.089-.113.186-.218.278-.329-.127-.149-.259-.295-.383-.447-1.476-1.812-2.91-3.668-4.209-5.658-1.304-1.985-2.529-4.049-3.613-6.254-.531-1.114-1.061-2.229-1.507-3.427l-.669-1.798c-.183-.639-.404-1.24-.554-1.913l-.097-.43.353-.352.27.256 5.062 4.805 4.981 4.887L0-1.051l.535.526z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -339.72 -100.419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-15.662L5.167-18.371l-20.829-18.371H0l20.828 18.371z",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -618.653 -1.412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-28.91l18.371 18.371-18.371 18.371H0l20.829-18.371Z",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -563.898 47.577)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.772 0-7.006-5.908-3.426-9.065l6.147-5.421a5.18 5.18 0 0 0 0-7.77l-6.147-5.422c-3.58-3.157-1.346-9.064 3.426-9.064 1.262 0 2.48.46 3.427 1.295l14.955 13.191a5.179 5.179 0 0 1 0 7.77L3.427-1.295A5.185 5.185 0 0 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -238.974 -1.412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.772 0-7.006-5.908-3.427-9.065l6.148-5.421a5.18 5.18 0 0 0 0-7.77l-6.148-5.422C-7.006-30.835-4.772-36.742 0-36.742c1.262 0 2.48.46 3.427 1.295l14.955 13.191a5.18 5.18 0 0 1 0 7.77L3.427-1.295A5.185 5.185 0 0 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -205.206 -1.412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-8.571 8.025V-8.132Z",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -354.875 23.011)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-7.81l18.313-18.312-19.425-18.43H0l20.828 18.371z",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -354.554 -1.412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-7.809l18.312-18.312-19.425-18.43H0l20.828 18.371z",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -331.944 -1.412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 18.422 18.422L.103 36.742H-15.04L3.331 18.371-15.04 0Z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -473.886 47.577)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-8.968l18.32-18.32-18.423-18.422H0l20.828 18.371z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -455.392 -1.412)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.773 0-7.006-5.908-3.427-9.065l6.147-5.421a5.18 5.18 0 0 0 0-7.77l-6.147-5.422C-7.006-30.835-4.773-36.742 0-36.742c1.262 0 2.479.46 3.426 1.295l14.956 13.191a5.18 5.18 0 0 1 0 7.77L3.426-1.295A5.183 5.183 0 0 1 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 10.51 0)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0a3.4 3.4 0 1 0-6.8 0A3.4 3.4 0 0 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 9.068 24.394)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.98 2.98 0 0 1 0-4.216l1.826-1.826c1.878-1.878.548-5.089-2.108-5.089h-14.355a2.981 2.981 0 0 1-2.981-2.98v-.004a2.981 2.981 0 0 1 2.981-2.981H-.283c2.656 0 3.986-3.211 2.108-5.089L0-24.01a2.98 2.98 0 0 1-.001-4.215L0-28.226a2.98 2.98 0 0 1 4.216 0l12.005 12.005a2.979 2.979 0 0 1 0 4.215L4.215 0A2.98 2.98 0 0 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -575.663 125.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3.436a2.982 2.982 0 1 1 0 5.965H0A2.982 2.982 0 0 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -614.491 148.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.43a2.261 2.261 0 0 1 2.261 2.262v1.441A2.261 2.261 0 0 1 .43 5.965H0a2.262 2.262 0 0 1-2.262-2.262V2.262A2.262 2.262 0 0 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -629.433 148.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-13.238h-17.974v-5.965H0v-13.238l17.974 16.22z",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -465.817 123.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.917 178.174h9.4v5.965h-9.4zM131.432 178.174h4.953v5.965h-4.953z",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -698.32 386.188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-7.374h-17.974v-5.965H0v-7.374c0-2.259 2.677-3.448 4.354-1.934l11.475 10.355a2.606 2.606 0 0 1 0 3.871L4.354 1.936C2.677 3.448 0 2.259 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -343.74 130.838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h6.418a2.982 2.982 0 1 1 0 5.965H0Z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -387.019 148.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.971a2.982 2.982 0 1 1 0 5.965H0Z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -401 148.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-11.271h-17.974v-5.965H0v-11.272a.874.874 0 0 1 1.46-.649c8.833 7.972 8.833 21.834 0 29.806A.874.874 0 0 1 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -225.222 125.642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.157a2.983 2.983 0 1 1 0 5.965H0Z",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -261.486 148.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.157a2.983 2.983 0 1 1 0 5.965H0Z",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -270.57 148.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.157a2.983 2.983 0 1 1 0 5.965H0Z",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -280.236 148.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.949 2.949 0 1 1 5.899 0A2.949 2.949 0 1 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -154.873 144.603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.95 2.95 0 1 1 5.9 0A2.95 2.95 0 0 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -167.095 144.603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.949 2.949 0 1 1 5.899 0A2.949 2.949 0 1 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -179.538 144.603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.612 0-5.303-4.472-2.593-6.861l4.653-4.104a3.923 3.923 0 0 0 0-5.882l-4.653-4.103c-2.71-2.39-1.019-6.862 2.593-6.862.955 0 1.878.349 2.594.981l11.321 9.984a3.922 3.922 0 0 1 0 5.882L2.594-.98A3.925 3.925 0 0 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -140.663 126.062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.612 0-5.303-4.472-2.594-6.861l4.654-4.104a3.923 3.923 0 0 0 0-5.882l-4.654-4.103C-5.303-23.34-3.612-27.812 0-27.812c.955 0 1.878.349 2.594.981l11.32 9.984a3.92 3.92 0 0 1 0 5.882L2.594-.98A3.925 3.925 0 0 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -116.44 126.062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-2.676c0-.718.338-1.394.914-1.823l11.505-8.607a.877.877 0 0 0 0-1.403L.914-23.114a2.282 2.282 0 0 1-.915-1.825v-2.676a.9.9 0 0 1 1.438-.72L19.71-14.668c.574.43.574 1.291 0 1.721L1.438.72A.899.899 0 0 1 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -588.714 230.013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.138-3.096a1.074 1.074 0 0 0 0-1.72L0-7.911a.899.899 0 0 0-1.437.722l-.002 6.468A.9.9 0 0 0 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -586.799 243.148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28.697c1.14 0 2.065.925 2.065 2.064v4.145c0 1.14-.925 2.063-2.065 2.063H0a2.063 2.063 0 0 1-2.064-2.063V2.064C-2.064.925-1.14 0 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -638.234 253.937)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.138-3.096a1.074 1.074 0 0 0 0-1.72L0-7.911a.899.899 0 0 0-1.437.722l-.002 6.468A.9.9 0 0 0 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -226.883 243.148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.139-3.096a1.075 1.075 0 0 0 0-1.72L.001-7.911a.9.9 0 0 0-1.438.722l-.001 6.468A.9.9 0 0 0 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -214.595 243.148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.139-3.096a1.075 1.075 0 0 0 0-1.72L.001-7.911a.9.9 0 0 0-1.438.722l-.001 6.468A.9.9 0 0 0 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -202.887 243.148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24.554a4.136 4.136 0 0 1 0 8.272H0A4.135 4.135 0 1 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -275.556 253.937)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.139-3.096a1.075 1.075 0 0 0 0-1.72L.001-7.911a.9.9 0 0 0-1.438.722l-.001 6.468A.9.9 0 0 0 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -149.154 243.148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.138-3.096a1.074 1.074 0 0 0 0-1.72L0-7.911a.899.899 0 0 0-1.437.722l-.002 6.468A.9.9 0 0 0 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -136.865 243.148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 10.54-7.885a2.738 2.738 0 0 0 0-4.383L.002-20.149c-1.511-1.129-3.662-.052-3.662 1.837l-.004 16.475C-3.664.052-1.511 1.13 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -120.967 234.99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-2.676c0-.718.338-1.394.914-1.823l11.505-8.607a.877.877 0 0 0 0-1.403L.914-23.114A2.281 2.281 0 0 1 0-24.939v-2.676a.899.899 0 0 1 1.437-.72L19.71-14.668c.575.43.575 1.291 0 1.721L1.438.72A.899.899 0 0 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -470.294 230.013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.625 2.625 0 0 0 0-4.203h-.001c-1.615-1.208-3.916-.057-3.916 1.96v.28C-3.918.056-1.616 1.208 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -465.073 245.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h29.979a2.846 2.846 0 1 1 0 5.692H0Z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -517.156 251.883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .05-2.676a2.269 2.269 0 0 1 .947-1.806l11.663-8.392a.876.876 0 0 0 .027-1.402L1.343-23.094a2.281 2.281 0 0 1-.881-1.842l.05-2.675a.9.9 0 0 1 1.451-.694L19.979-14.3c.566.44.55 1.302-.033 1.72L1.424.746A.899.899 0 0 1 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -351.293 229.813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 30.32.563a2.502 2.502 0 0 1 2.454 2.547l-.062 3.27a2.5 2.5 0 0 1-2.546 2.454l-30.32-.563Z",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -399.403 254.636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a3.472 3.472 0 0 1 3.407 3.536l-.025 1.327A3.471 3.471 0 0 1-.154 8.271a1.814 1.814 0 0 1-1.779-1.846l.087-4.647A1.812 1.812 0 0 1 0 0",
    style: {
      fill: "#ea6632",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -350.233 253.722)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(1.33333 0 0 -1.33333 -698.32 386.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0a7.394 7.394 0 0 1-1.108-1.453l-.466.241a.604.604 0 1 1-.334-.68l.451-.234a7.26 7.26 0 0 1-.539-1.744l.746-.131A6.6 6.6 0 0 0 .542-.529z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(260.104 34.534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.171 0-.341-.007-.51-.018l-.073.626a.718.718 0 1 1-1.158.478.717.717 0 0 1 .405-.564l.073-.624a7.564 7.564 0 0 1-2.059-.646l.327-.684A6.862 6.862 0 0 0 0-.759c.496 0 .993-.053 1.475-.157l.161.741A7.798 7.798 0 0 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(265.592 36.837)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a.603.603 0 1 1-.677.59l-.416-.363a7.635 7.635 0 0 1-1.408 1.138l-.403-.64A6.755 6.755 0 0 0-.341-2.201l.691.312A7.353 7.353 0 0 1-.593-.344l.403.352A.573.573 0 0 1 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(272.194 34.29)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a19.505 19.505 0 0 0-1.157-.034c-.88 0-1.733.06-2.478.179a8.65 8.65 0 0 0-1.27.292A6.171 6.171 0 0 1 .483-2.688c2.856 0 5.262 1.916 5.95 4.503C5.751 1.366 4.927.99 3.974.692 2.795.325 1.42.086 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(265.044 26.628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a1.361 1.361 0 0 0 0 2.721A1.361 1.361 0 0 0 0 0m-4.737-.908c-1.021 0-1.85.83-1.85 1.849a1.85 1.85 0 0 0 1.85 1.85A1.851 1.851 0 0 0-2.888.941c0-1.019-.83-1.849-1.849-1.849m2.159 6.514c-3.353 0-6.079-2.666-6.079-5.943 0-.426.046-.849.136-1.262.674-.482 2.707-.889 5.348-.73 2.879.173 5.297.957 6.672 2.158-.005.195-.02.391-.045.582C3.074 3.373.48 5.606-2.578 5.606",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(268.17 29.714)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.295.116-.806.309-1.383.237-.551-.068-.844-.34-.844-1.007v-.865H.001v-1.718h-2.228v-5.454h-1.931v5.454h-1.34v1.718h1.34v.888c0 1.681.895 2.783 2.568 2.783.643 0 1.157-.122 1.59-.308z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(281.596 33.453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.177.03-.357.047-.526.047-.896 0-1.51-.548-1.51-1.614v-3.908h-1.932v7.172h1.873V.912c.451.674 1.14.978 2.021.978.414 0 .847-.128 1.094-.337z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(286.298 30.121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3.176c-.178.918-.734 1.436-1.563 1.436C.703 1.436.171.889 0 0m5.114-.666c0-.222-.014-.488-.037-.651H-.007C.2-2.354.926-2.805 1.836-2.805c.621 0 1.295.251 1.813.688L4.781-3.36c-.813-.747-1.85-1.088-3.056-1.088-2.199 0-3.723 1.495-3.723 3.753 0 2.257 1.48 3.797 3.626 3.797 2.065 0 3.479-1.533 3.486-3.768",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(288.85 28.91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3.176c-.178.918-.734 1.436-1.563 1.436C.703 1.436.17.889 0 0m5.114-.666c0-.222-.014-.488-.037-.651H-.007C.2-2.354.925-2.805 1.836-2.805c.621 0 1.295.251 1.813.688L4.781-3.36c-.814-.747-1.85-1.088-3.056-1.088-2.199 0-3.723 1.495-3.723 3.753 0 2.257 1.48 3.797 3.626 3.797 2.065 0 3.479-1.533 3.486-3.768",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(296.504 28.91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-1.132.748-1.976 1.843-1.976 1.139 0 1.85.881 1.85 1.976 0 1.096-.711 1.977-1.85 1.977C.748 1.977 0 1.133 0 0m5.677 0c0-2.153-1.495-3.774-3.471-3.774-.963 0-1.644.378-2.109.932V-6.55h-1.925V3.583H.06v-.792c.465.584 1.154.984 2.138.984 1.984 0 3.479-1.621 3.479-3.775",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(304.287 28.235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.809 24.646h-1.932v7.172h1.932zm.258 9.518c0-.695-.54-1.228-1.235-1.228-.696 0-1.229.533-1.229 1.228a1.22 1.22 0 0 0 1.229 1.243c.695 0 1.235-.547 1.235-1.243",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.701 2.554H5.07L1.591-.821l3.501-3.797H2.716L0-1.717v-2.901h-1.932V6.039H0Z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(316.032 29.265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v3.208c-.396.615-1.245 1.143-2.124 1.143-1.421 0-2.271-1.172-2.271-2.74 0-1.567.85-2.724 2.271-2.724C-1.245-1.113-.396-.615 0 0m0-1.919v1.055c-.527-.718-1.392-1.231-2.388-1.231-1.845 0-3.149 1.407-3.149 3.706 0 2.256 1.289 3.721 3.149 3.721.952 0 1.817-.469 2.388-1.245v3.765h1.099v-9.771z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(184.413 26.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.509 0-2.256-1.274-2.314-2.358h4.643C2.314-1.304 1.611 0 0 0m-3.471-2.798C-3.471-.747-2.007.908.015.908c2.138 0 3.398-1.67 3.398-3.794v-.278h-5.727C-2.227-4.497-1.289-5.61.234-5.61c.806 0 1.626.322 2.183.893l.527-.718C2.241-6.138 1.289-6.519.132-6.519c-2.095 0-3.603 1.509-3.603 3.721",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(190.403 31.054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .571.791C1.04.249 1.934-.22 2.9-.22c1.084 0 1.67.513 1.67 1.216 0 1.714-4.38.659-4.38 3.281 0 1.099.953 2.036 2.637 2.036 1.201 0 2.051-.454 2.622-1.025l-.513-.762c-.424.513-1.201.894-2.109.894-.967 0-1.567-.483-1.567-1.113 0-1.553 4.379-.528 4.379-3.282 0-1.186-.952-2.138-2.783-2.138C1.699-1.113.718-.762 0 0",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(194.607 25.648)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.667 31.786h1.099v-7.075h-1.099zm-.19 1.743c0 .41.337.747.732.747a.75.75 0 0 0 .747-.747.737.737 0 0 0-.747-.732.734.734 0 0 0-.732.732",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v3.091c-.381.615-1.23 1.142-2.109 1.142-1.421 0-2.27-1.128-2.27-2.695 0-1.553.849-2.695 2.27-2.695C-1.23-1.157-.381-.615 0 0m-5.126-3.853.556.821c.586-.703 1.289-.967 2.3-.967 1.172 0 2.27.571 2.27 2.124v1.011c-.512-.718-1.376-1.26-2.373-1.26-1.845 0-3.149 1.377-3.149 3.662 0 2.271 1.289 3.677 3.149 3.677.952 0 1.802-.469 2.373-1.245v1.069h1.099v-6.87c0-2.344-1.641-3.076-3.369-3.076-1.201 0-2.022.234-2.856 1.054",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(209.708 26.747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v4.629C0 5.874-.629 6.27-1.582 6.27c-.864 0-1.685-.528-2.094-1.099V0h-1.099v7.075h1.099V6.05c.498.586 1.464 1.201 2.519 1.201 1.479 0 2.256-.747 2.256-2.285V0Z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(217.413 24.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.509 0-2.256-1.274-2.314-2.358h4.643C2.314-1.304 1.611 0 0 0m-3.472-2.798C-3.472-.747-2.007.908.015.908c2.138 0 3.398-1.67 3.398-3.794v-.278h-5.727C-2.227-4.497-1.289-5.61.234-5.61c.806 0 1.626.322 2.183.893l.527-.718C2.241-6.138 1.289-6.519.132-6.519c-2.095 0-3.604 1.509-3.604 3.721",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(223.404 31.054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v3.208c-.396.615-1.245 1.143-2.124 1.143-1.421 0-2.271-1.172-2.271-2.74 0-1.567.85-2.724 2.271-2.724C-1.245-1.113-.396-.615 0 0m0-1.919v1.055c-.527-.718-1.392-1.231-2.388-1.231-1.845 0-3.149 1.407-3.149 3.706 0 2.256 1.289 3.721 3.149 3.721.952 0 1.817-.469 2.388-1.245v3.765h1.099v-9.771z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(233.35 26.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.436 0 2.285 1.157 2.285 2.725 0 1.567-.849 2.739-2.285 2.739-.864 0-1.729-.527-2.109-1.143V1.113C-1.729.498-.864 0 0 0m-3.208-.806v9.771h1.099V5.2c.571.777 1.421 1.245 2.387 1.245 1.846 0 3.15-1.465 3.15-3.72 0-2.3-1.304-3.706-3.15-3.706-.996 0-1.86.512-2.387 1.23V-.806z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(242.9 25.517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a1.69 1.69 0 0 1 .601-.117c.483 0 .805.161 1.055.747l.469 1.069-2.96 7.149H.352L2.71 3.047l2.344 5.801h1.201L2.71.337C2.285-.688 1.567-1.084.63-1.099c-.234 0-.601.044-.805.103z",
    style: {
      fill: "#112129",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(247.528 22.939)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.ebc23e2238977b0e7024a83b5c043630.svg";
export { ForwardRef as ReactComponent };